var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var controllers;
    (function (controllers) {
        var SendEmailSettingsModalController = /** @class */ (function (_super) {
            __extends(SendEmailSettingsModalController, _super);
            function SendEmailSettingsModalController($scope, workflowBlock, processConfigId, isReadonly, emailConfigurationService, systemLevelService, securityMatrixService, workflowService, close) {
                var _this = _super.call(this, $scope, close) || this;
                _this.$scope = $scope;
                _this.processConfigId = processConfigId;
                _this.securityMatrixService = securityMatrixService;
                _this.$scope.workflowBlock = workflowBlock;
                _this.$scope.isReadonly = isReadonly;
                _this.$scope.securityMatrixService = _this.securityMatrixService;
                _this.$scope.changeHasSecurity = function () { return _this.changeHasSecurity(); };
                _this.$scope.emailConfigurations = [];
                systemLevelService.getSystemEmailConfigurations().then(function (sysLevel) {
                    _this.$scope.emailConfigurations = _this.$scope.emailConfigurations.concat(sysLevel.myEmailConfigurations);
                });
                emailConfigurationService.getAllEmailConfigurationsByProcessId(processConfigId)
                    .then(function (emailConfigurations) {
                    _this.$scope.emailConfigurations = _this.$scope.emailConfigurations.concat(emailConfigurations);
                });
                if (workflowBlock.sendEmailDto.securityMatrixId) {
                    securityMatrixService.fetchById(workflowBlock.sendEmailDto.securityMatrixId, "SecurityMatrix")
                        .then(function (securityMatrix) {
                        _this.$scope.securityMatrix = securityMatrix;
                        _this.$scope.securityMatrixInfoLoaded = true;
                    });
                }
                return _this;
            }
            SendEmailSettingsModalController.prototype.changeHasSecurity = function () {
                if (this.$scope.workflowBlock.sendEmailDto.hasSecurity) {
                    var securityMatrix = this.$scope.securityMatrixService.createSecurityRowWithSubTypes(false);
                    this.$scope.securityMatrix = securityMatrix;
                    this.$scope.workflowBlock.sendEmailDto.securityMatrixId = securityMatrix.id;
                    this.$scope.securityMatrixInfoLoaded = true;
                    this.$scope.securityMatrixService.saveChanges([securityMatrix]);
                }
                else {
                    this.$scope.workflowBlock.sendEmailDto.securityMatrixId = null;
                }
            };
            return SendEmailSettingsModalController;
        }(controllers.BaseModalController));
        controllers.SendEmailSettingsModalController = SendEmailSettingsModalController;
    })(controllers = warsApp.controllers || (warsApp.controllers = {}));
})(warsApp || (warsApp = {}));
warsApp.registerController('SendEmailSettingsModalController', ['$scope', 'workflowBlock', 'processConfigId', 'isReadonly', 'emailConfigurationService', 'systemLevelService', 'securityMatrixService', 'workflowService', 'close']);
